<div class="tooltip-container" *ngIf="!!text" [ngClass]="{'disabled': disabled}">
  <span *ngIf="link !== 'icon'" [ngClass]="linkCss" class="tooltip-link" (click)="toggleTooltip()">{{ link }}</span>
  <span *ngIf="link === 'icon' || useBothTogglers" class="icon-info" (click)="toggleTooltip()"></span>
  <div class="tooltip-wrapper" [ngClass]="{'active': active}">
    <div class="tooltip-text">{{ text }}</div>
    <span class="icon-close" (click)="toggleTooltip()"></span>
  </div>
</div>
